
export default {
  name: 'ReviewsViewLazyImage',
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: 'image',
    },
    imgClass: {
      type: String,
      default: '',
    },
    imageClass: {
      type: String,
      default: '',
    },
    usePicture: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      required: true,
    },
    sources: {
      type: Array,
    },
  },
  data() {
    return {
      isLoaded: false,
    };
  },
  methods: {
    onLoad() {
      const img = this.$refs[`lazy-image-${this.index}`]?.$el?.querySelector('img');
      if (img && !img.getAttribute('src').includes('data:image')) {
        this.isLoaded = true;
        this.$emit('load', this.index);
      }
    },
  },
};
